export default __webpack_public_path__ + "static/media/SUSHI.e.4b15c8ee.png";